import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>Fuel Innovation: Promote Unchallenged Growth with our React Native application development services</h2>
                               <p>We provide a complete range of React Native app development solutions matching businesses' unique needs and choices, encompassing small, medium, and big enterprises, entrepreneurs, and startups. Our React Native app developers can craft your app in 2 to 3 months.</p> 
                               <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let's Build Your React Native App</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>Cross-Platform Efficiency:</h6>
                        <p>React Native allows simultaneous development for Android and iOS, saving time and cost. A sole codebase warrants consistent functionality and platform updates, permitting easy maintenance.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Cost-Effectiveness:</h6>
                        <p>Reduce development costs with both platforms' shared codebase and seamless development team. React Native also decreases time to market, which improves efficiency.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Performance and User Experience:</h6>
                        <p>React Native is known to provide a near-native performance as it ensures a responsive and flawless user experience. Gain access to a vast library of pre-built components, which will improve UI development and optimize app performance.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp